function getVisibleTopHeight(element: HTMLElement): number {
	const { top, bottom } = element.getBoundingClientRect();

	return Math.max(0, Math.min(bottom, window.innerHeight) - Math.max(top, 0));
}

export function getFixedHeaderOffset(extraOffset = 0): number {
	if (!import.meta.client) return extraOffset;

	const fixedHeaders = document.querySelectorAll<HTMLElement>(
		'[data-fixed-header]'
	);

	const visibleHeaderHeight = Array.from(fixedHeaders).reduce(
		(total, element) => total + getVisibleTopHeight(element),
		0
	);

	return visibleHeaderHeight + extraOffset;
}

export function getScrollTopForElement(
	element: Element,
	extraOffset = 0
): number {
	return Math.max(
		0,
		element.getBoundingClientRect().top +
			window.scrollY -
			getFixedHeaderOffset(extraOffset)
	);
}
